import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HelpComponent {
  @Input() page?: string;

  public texts: Array<Object>;

  constructor(
    private translateService: TranslateService
  ) {}

  buttonClicked($event) {
    if($event == true){
      this.texts = [];
      this.translateService.get('help.pages').subscribe(res => {
        if (this.page != null && res[this.page] != undefined) {
          let keys = Object.keys(res[this.page])
          for(let k = 0; k < keys.length; k++){
            let obj = res[this.page][keys[k]]
            obj['key'] = keys[k];
            this.texts.push(obj)
          }
        }
      });
    }
  }

}
